import { useAppConfigStore, useOutlookStore, useSettingStore, useThemeStore } from "@shared/stores";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import HStack from "@components/layout/HStack";
import TitleSetting from "@components/ui/TitleSetting";
import Accordion from "@components/ui/Accordion";
import { settingLabels } from "@shared/constants/setting";
import SwitchSetting from "@components/ui/SwitchSetting";
import Divider from "@components/ui/Divider";
import VStack from "@components/layout/VStack";
import {
  OrganizerSettingEntity,
  TileConfigurationEntity,
} from "@features/settings/services/entities/organizerSettingEntity";
import { useCreateOrganizerSetting } from "@features/settings/services/useCreateOrganizerSetting";
import { useGlobalContext } from "@shared/contexts/GlobalContext";
import {
  AppsIcon,
  CategoryIcon,
  CityIcon,
  LocationIcon,
  PhotoFilterIcon,
  TimelineIcon,
} from "@/pages/taskpane/components/icons/IconCustom";

const TileConfigurationSetting = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useThemeStore();
  const [isOpen, setIsOpen] = useState(false);

  const header = (
    <HStack justifyContent="between" className="w-full" onClick={() => setIsOpen(!isOpen)}>
      <TitleSetting icon={<AppsIcon isDarkMode={isDarkMode} />} label={t(settingLabels.tileConfiguration)} />
    </HStack>
  );
  return (
    <Accordion header={header} isOpen={isOpen} onToggleOpen={() => setIsOpen(!isOpen)}>
      {isOpen ? <TileConfigurationSettingContent /> : null}
    </Accordion>
  );
};

export default TileConfigurationSetting;

const TileConfigurationSettingContent = () => {
  const { t } = useTranslation();
  const { setIsLoadingOverlay } = useGlobalContext();
  const { isDarkMode } = useThemeStore();
  const { parameters } = useAppConfigStore();
  // const showToast = useToastStore((state) => state.showToast);
  const { organizer } = useOutlookStore();
  const { tileConfiguration, setTileConfiguration } = useSettingStore();
  // const queryClient = useQueryClient();

  const { mutate: updateTileConfigurationMutation } = useCreateOrganizerSetting({
    mutationConfig: {
      onSuccess: (data: OrganizerSettingEntity) => {
        setTileConfiguration(new TileConfigurationEntity(data.tileConfiguration));
        // showToast(t("Update settings successfully"), true);
        // queryClient.setQueryData([QUERY_KEY.GET_ORGANIZER_SETTING, organizer], (oldData: OrganizerSettingEntity) => {
        //   return {
        //     ...oldData,
        //     tileConfiguration: data.tileConfiguration,
        //   };
        // });
      },
      onError: () => {
        // showToast(t("Update settings failed"), false);
      },
      onSettled: () => {
        setIsLoadingOverlay(false);
      },
    },
  });

  const handleToggleResourceType = (type: keyof TileConfigurationEntity) => {
    if (!organizer) return;
    setIsLoadingOverlay(true);
    const newTileConfiguration = new TileConfigurationEntity({
      ...tileConfiguration,
      [type]: !tileConfiguration?.[type],
    });
    updateTileConfigurationMutation({
      organizerEmail: organizer,
      tileConfiguration: newTileConfiguration,
    });
  };

  return (
    <div className="w-full p-[2px]">
      <Divider className="my-3" />
      <VStack className="w-full" gap={3}>
        <SwitchSetting
          icon={<CityIcon isDarkMode={isDarkMode} />}
          label={t("Resource Type")}
          isChecked={tileConfiguration.resourceType}
          onAction={() => handleToggleResourceType("resourceType")}
        />

        <SwitchSetting
          icon={<LocationIcon isDarkMode={isDarkMode} />}
          label={t("Location")}
          isChecked={tileConfiguration.location}
          onAction={() => handleToggleResourceType("location")}
        />

        <SwitchSetting
          icon={<PhotoFilterIcon isDarkMode={isDarkMode} />}
          label={t("Capacity")}
          isChecked={tileConfiguration.capacity}
          onAction={() => handleToggleResourceType("capacity")}
        />

        <SwitchSetting
          icon={<CategoryIcon isDarkMode={isDarkMode} />}
          label={t("Category")}
          isChecked={tileConfiguration.category}
          onAction={() => handleToggleResourceType("category")}
        />

        {parameters?.outlookAddinTimeLineVisible ? <SwitchSetting
          icon={<TimelineIcon isDarkMode={isDarkMode} />}
          label={t("Timeline")}
          isChecked={tileConfiguration.timeline}
          onAction={() => handleToggleResourceType("timeline")}
        /> : null}
      </VStack>
    </div>
  );
};
